module.exports = __webpack_public_path__ + "img/IMAGE 3.5845f674.png";